import React, { useEffect } from "react";
import DOMPurify from "dompurify";
export var SafeHTMLDisplay = function (_a) {
    var html = _a.html;
    var safeHTML = DOMPurify.sanitize(html);
    useEffect(function () {
        DOMPurify.addHook("afterSanitizeAttributes", function (node) {
            if (node.tagName === "A") {
                node.setAttribute("target", "_blank");
                node.setAttribute("rel", "noopener noreferrer");
            }
            return node;
        });
    }, []);
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } });
};
